import { useContext } from "react";

import OrderContext from "~/contexts/OrderContext";
import SiteContext from "~/contexts/SiteContext";
import { OrderFulfillmentType, OrderSource } from "~/entities/orderEntities";
import { minimumOrderFor, settingsFor } from "~/helpers/leadTime";

// The minimum order for the current order type at this store, measured the way the server checks it: items at full
// price, before discounts and without delivery or other charges (lineTotalBeforeDiscount)
export const useMinimumOrder = () => {
  const { orderSummary, orderType, orderSource } = useContext(OrderContext);
  const { site } = useContext(SiteContext);
  const minimum = minimumOrderFor(
    settingsFor(site?.serviceSettings, orderType?.code),
  );
  const subtotal = orderSummary.lineTotalBeforeDiscount ?? 0;
  const remaining = Math.max(0, minimum - subtotal);
  const delivery = orderType?.fulfillmentType === OrderFulfillmentType.DELIVERY;
  return {
    minimum,
    subtotal,
    remaining,
    // Nothing to do when there's no minimum
    applies: minimum > 0,
    reached: remaining === 0,
    // "Catering pickup", "Catering delivery", else the order type's own name
    kindLabel:
      orderSource === OrderSource.CATERING
        ? `Catering ${delivery ? "delivery" : "pickup"}`
        : (orderType?.name ?? "This order"),
    hasPromo: !!(orderSummary.promoCode || orderSummary.redemptionKey),
    storeName: site?.siteName ?? "",
    progress: minimum > 0 ? Math.min(1, subtotal / minimum) : 1,
  };
};
